module.exports = __webpack_public_path__ + "img/meiti2.60dbab8f.svg";